import { STATIC_STRINGS } from "@asez/shared";
import { FILTER_KEYS } from "@asez/shared";
import { FilterListItem } from "./FilterListItem";
import { initialFilters } from "./index";
import { RangeSlider } from "./RangeSlider";

export const MarksFilter = ({ filters, updateFilters }) => {
  return (
    <FilterListItem
      filterName={STATIC_STRINGS.TOTAL_MARKS}
      resetHandler={() => {
        updateFilters(FILTER_KEYS.MARKS, initialFilters[FILTER_KEYS.MARKS]);
      }}
      Component={
        <RangeSlider
          filters={filters}
          filterKey={FILTER_KEYS.MARKS}
          updateFilters={updateFilters}
        />
      }
    />
  );
};
